import React from 'react';
import { ViewContainer, WonoloSpinner } from 'components/common/loaders/styles';
import logo from './assets/wonolo_small.png';

const WonoloSpinnerLoader = () => (
  <ViewContainer>
    <WonoloSpinner src={logo} alt="Loading..." />
  </ViewContainer>
);

export default WonoloSpinnerLoader;
